import { WaitingMember } from '../../shared/waitingMember';
import { testPatientData } from './testPatientData';
import { RealtimeRole } from '@doxyme/types';
import { RealtimeMemberStatus } from '../../features/realtime/realtime.types';

export const getTestWaitingMember = (roomId: string): WaitingMember => {
  return {
    roomId,
    id: testPatientData.id,
    chatUserId: testPatientData.id,
    picture: testPatientData.avatarUrl,
    joinedAt: Date.now(),
    isTestPatient: true,
    state: {
      status: RealtimeMemberStatus.Online,
      username: testPatientData.username,
      privateData: {
        ip: testPatientData.testIp,
        location: {
          country_code: testPatientData.countryCode,
          country_name: testPatientData.countryName,
          region_name: testPatientData.state,
        },
      },
      hasAudio: true,
      hasVideo: true,
    },
    identity: {
      id: testPatientData.id,
      role: RealtimeRole.Patient,
    },
  };
};
